import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';

export default function Barrierefreiheit() {
  return (
    <Box sx={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      p: 3 
    }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Erklärung zur Barrierefreiheit
        </Typography>
        
        <Typography paragraph>
          Wir sind bemüht, diese Websites und mobilen Anwendungen im Einklang mit der Bayerischen E-Government-Verordnung (BayEGovV) 
          barrierefrei zugänglich zu machen. Diese Erklärung zur Barrierefreiheit gilt für die Website https://sozialgerichtsbarkeit.de/.
        </Typography>

        <Typography paragraph>
          Zur Prüfung wurden einige repräsentative Seiten ausgewählt, d.h. einer Seitenauswahl, die möglichst alle potentiellen 
          Barrieren erfasst, jedoch auf die Zugänglichkeit des Webauftritts als Ganzen schließen lassen sollte. Im Zugänglichkeitstest 
          wird geprüft, inwieweit Menschen mit der Anwendung arbeiten können, wenn sie auf bestimmte Eingabe-/Ausgabemittel wie 
          Screenreader, Bildschirmlupen, Kontrastmodus oder Tastaturbedienung angewiesen sind.
        </Typography>

        <Typography paragraph>
          Wir achten auf inhaltliche Gesichtspunkte, wie Verständlichkeit und Benutzerfreundlichkeit.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Stand der Vereinbarkeit mit den Anforderungen
        </Typography>
        <Typography paragraph>
          Diese Website ist mit BITV 2.0 vereinbar.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Nicht barrierefreie Inhalte
        </Typography>
        <Typography paragraph>
          Nicht barrierefreie Inhalte waren nicht feststellbar.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Erstellung dieser Erklärung zur Barrierefreiheit
        </Typography>
        <Typography paragraph>
          Die Erklärung basiert auf einem BITV-Selbsttest nach{' '}
          <Link href="https://www.bitvtest.de/start.html" target="_blank" rel="noopener">
            https://www.bitvtest.de/start.html
          </Link>
          ; Stand 01.09.2010
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Feedback und Kontaktangaben
        </Typography>
        <Typography paragraph>
          Etwaige Mängel in Bezug auf die Einhaltung der Barrierefreiheitsanforderungen können Sie uns mitteilen unter{' '}
          <Link href="mailto:webmaster@lsg.bayern.de">webmaster@lsg.bayern.de</Link>
        </Typography>
        <Typography paragraph>
          Informationen über von der Anwendung der Richtlinie ausgenommene Inhalte können Sie unter{' '}
          <Link href="mailto:webmaster@lsg.bayern.de">webmaster@lsg.bayern.de</Link> einholen.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Zuständige Stelle
        </Typography>
        <Typography paragraph>
          Zuständig für die barrierefreie Zugänglichkeit und die Bearbeitung der im Rahmen des Feedback-Mechanismus eingehenden 
          Mitteilungen ist:
        </Typography>
        <Typography component="div" sx={{ ml: 2 }}>
          Bayer. Landessozialgericht<br />
          Ludwigstraße 15<br />
          80539 München<br />
          E-Mail: <Link href="mailto:webmaster@lsg.bayern.de">webmaster@lsg.bayern.de</Link>
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Durchsetzungsverfahren
        </Typography>
        <Typography paragraph>
          Bleibt Ihre Anfrage innerhalb von sechs Wochen ganz oder teilweise unbeantwortet, so haben Sie die Möglichkeit, bei der 
          Durchsetzungsstelle online einen Antrag auf Prüfung der Einhaltung der Anforderungen an die Barrierefreiheit zu stellen:
        </Typography>
        <Typography paragraph>
          <Link href="#" sx={{ fontWeight: 'bold' }}>
            Antrag auf Prüfung der Anforderungen an die Barrierefreiheit gem. § 3 BayEGovV
          </Link>
        </Typography>
        <Typography paragraph>
          Oder Sie wenden sich an nachfolgende Kontaktadresse der Durchsetzungsstelle:
        </Typography>
        <Typography component="div" sx={{ ml: 2 }}>
          Landesamt für Digitalisierung, Breitband und Vermessung<br />
          IT-Dienstleistungszentrum des Freistaats Bayern<br />
          Durchsetzungs- und Überwachungsstelle für barrierefreie Informationstechnik<br />
          St.-Martin-Straße 47<br />
          81541 München<br />
          E-Mail: <Link href="mailto:bitv@bayern.de">bitv@bayern.de</Link>
        </Typography>

        <Typography paragraph sx={{ mt: 2 }}>
          <Link href="https://www.ldbv.bayern.de/digitalisierung/bitv.html" target="_blank" rel="noopener">
            https://www.ldbv.bayern.de/digitalisierung/bitv.html
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
} 